import Url from './urls.json'

function getCanonical (rel, language, media) {
  var link = ''
  var links = document.getElementsByTagName('link')
  for (var i = 0; i < links.length; i++) {
    if (language !== '' && links[i].getAttribute('hreflang') === language && links[i].getAttribute('rel') === rel) {
      link = links[i]
    } else if (language === '' && media !== '' && links[i].getAttribute('media') === media && links[i].getAttribute('rel') === rel) {
      link = links[i]
    } else if (language === '' && links[i].getAttribute('rel') === rel) {
      link = links[i]
    }
  }
  if (link === '') { link = document.createElement('link') }
  return link
}

function getAlternativePath (name, params, language) {
  name = name || 'HomePage'
  if (!Url[language][name]) {
    return ''
  }

  if (Url[language][name].indexOf('/:') > -1) return ''
  var newPath = location.protocol + '//' + location.host + Url[language][name].replace('(\\w+-\\w+-\\w+-\\w+|\\w+-\\w+-\\w+|\\w+-\\w+)', '')
  var regexRes = newPath.match(/\/:\w+/g)
  if (regexRes !== null) {
    regexRes.forEach(item => {
      newPath = newPath.replace(item, '/' + params[item.replace('/:', '')])
    })
  }
  return newPath
}

function addDeviceCanonical (url, path, media) {
  // <link rel="alternate" media="only screen and (max-width: 1000px)" href="https://m.eurekosigorta.com.tr/">
  var alternateMobile = getCanonical('alternate', null, media)
  alternateMobile.setAttribute('rel', 'alternate')
  alternateMobile.setAttribute('media', media)
  alternateMobile.setAttribute('href', url + (path || location.pathname))

  document.head.appendChild(alternateMobile)
}

function getCurrentUrl (path) {
  return location.protocol + '//' + location.host + (path || location.pathname)
}

const canonical = {
  add: function (currentLang, path, name, params) {
    var currentUrl = getCurrentUrl(path)
    currentUrl = currentUrl.replace(location.host, 'www.eurekosigorta.com.tr')
    var canonical = getCanonical('canonical', '')
    canonical.setAttribute('rel', 'canonical')
    canonical.setAttribute('href', currentUrl)
    document.head.appendChild(canonical)
  },
  remove: function (currentLang, path, name, params) {
    var canonical = getCanonical('canonical', '')
    if (typeof canonical.remove === 'function') {
      canonical.remove()
    }
  },
  addLanguage: function (currentLang, path, name, params) {
    var currentUrl = getCurrentUrl(path)
    var alternateTR = getCanonical('alternate', 'tr')
    alternateTR.setAttribute('rel', 'alternate')
    alternateTR.setAttribute('hreflang', 'tr')
    var alternativePathTR = getAlternativePath(name, params, 'tr') || ''
    alternateTR.setAttribute('href', (currentLang === 'tr') ? currentUrl : getAlternativePath(name, params, 'tr'))

    var alternateEN = getCanonical('alternate', 'en')
    alternateEN.setAttribute('rel', 'alternate')
    alternateEN.setAttribute('hreflang', 'en')
    var alternativePathEN = getAlternativePath(name, params, 'en') || ''
    alternateEN.setAttribute('href', (currentLang === 'en') ? currentUrl : getAlternativePath(name, params, 'en'))
    if (alternativePathTR !== '') {
      document.head.appendChild(alternateTR)
    } else {
      // alternateTR.remove()
    }
    if (alternativePathEN !== '') {
      document.head.appendChild(alternateEN)
    } else {
      // alternateEN.remove()
    }
  },
  addMobile: function (path) {
    addDeviceCanonical('https://m.eurekosigorta.com.tr', path, 'only screen and (max-width: 1000px)')
  }
}

export { canonical }



// WEBPACK FOOTER //
// ./src/router/canonical.js